export const RETURN_PORTAL_PRODUCTS_LS_KEY = 'products';
export const RETURN_PORTAL_METHODS_LS_KEY = 'returnMethods';
export const RETURN_PORTAL_TOKEN_LS_KEY = 'token';
export const RETURN_PORTAL_LANG_LS_KEY = 'language';
